/* eslint-disable import/no-duplicates */
import {Locale, isValid} from 'date-fns';
import {format} from 'date-fns/format';
import {enUS as en} from 'date-fns/locale/en-US';
import {ru} from 'date-fns/locale/ru';
import i18n from 'i18next';
import defaultsDeep from 'lodash/defaultsDeep';

export type TSettings = {
  locale: Record<string, Locale>;
  format: string;
  formatter: (date: Date, format: string, options: {locale: Locale}) => string;
};

export const defaultSettings: TSettings = {
  locale: {ru, en},
  format: 'HH:mm:ss dd.MM.yyyy',
  formatter: format,
};

export const setDefaultSettings = <S extends TSettings = TSettings>(
  payloadSettings: Partial<S>,
) => {
  Object.assign(defaultSettings, payloadSettings);
};

const formatDate = <S extends TSettings = TSettings>(date: Date, payloadSettings?: Partial<S>) => {
  if (isValid(date)) {
    const lang = i18n.language;
    const settings = defaultsDeep(payloadSettings, defaultSettings);

    return settings.formatter(date, settings.format, {locale: settings.locale[lang]});
  }

  return null;
};

export default formatDate;
/* eslint-enable import/no-duplicates */
